import React from 'react';
import { createPortal } from 'react-dom';
import { AppIcon, LogoutIcon, XIcon } from '../../components/icons';
import './LogoutConfirmationModal.css';

interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function LogoutConfirmationModal({ isOpen, onClose, onConfirm }: LogoutConfirmationModalProps) {
  if (!isOpen) return null;

  return createPortal(
    <div className="logout-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="logout-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="logout-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="logout-modal__aurora" aria-hidden />

        <button type="button" className="logout-modal__close" onClick={onClose} aria-label="Close">
          <AppIcon icon={XIcon} size={16} />
        </button>

        <div className="logout-modal__content">
          <div className="logout-modal__icon-frame" aria-hidden>
            <AppIcon icon={LogoutIcon} size={28} />
          </div>

          <h2 id="logout-modal-title" className="logout-modal__title">
            Sign Out
          </h2>
          
          <p className="logout-modal__text">
            Are you sure you want to sign out of ReffConnect? You will need to log back in to access your dashboard.
          </p>

          <div className="logout-modal__actions">
            <button
              type="button"
              className="logout-modal__btn logout-modal__btn--cancel"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="logout-modal__btn logout-modal__btn--confirm"
              onClick={onConfirm}
            >
              Log Out
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
